// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ZeMZ","selects":"Documents_selects__3DVCz"};